import "./ClearChat.css";

const ClearChat = ({ setChatLog }) => {
  function clearChat() {
    setChatLog([{ user: "ai", message: "How can I help you today?" }]);
  }

  return (
    <div className="side-menu-button" onClick={clearChat}>
      <img className="logo" src="./logo.png" alt="Logo" />
      <h4>+ new chat</h4>
    </div>
  );
};

export default ClearChat;
